export default __webpack_public_path__ + "static/media/04.457db01f.jpg";